import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useTheme } from '@mui/material/styles'; // Importa el hook useTheme

import { hideScroll } from 'src/theme/css';

import Logo from 'src/components/logo';
import { NavSectionMini } from 'src/components/nav-section';

import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import NavToggleButton from '../common/nav-toggle-button';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = useMockedUser();

  const navData = useNavData();

  const theme = useTheme(); // Hook para obtener el tema actual

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (themeObj) => `dashed 1px ${themeObj.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo  pathLogo={
            theme.palette.mode === 'dark'
              ? '/logo/logo_mini_dark.png'
              : '/logo/logo_mini.png'
          } sx={{ mx: 'auto', my: 2, width: 35, height: 35 }} />

        <NavSectionMini
          data={navData}
          slotProps={{
            currentRole: user?.role,
          }}
        />
      </Stack>
    </Box>
  );
}
